import { useQuery } from '@tanstack/react-query';
import { getClientLogo, getClientSignInLogo, getMicrosoftDetails, getMicrosoftSSOAuthUrl } from 'api/services';
import ActionButton from 'modules/auth/components/ui/ActionButton';
import useAuthSelector from 'modules/shared/hooks/useAuthSelector';
import { toast } from 'react-toastify';

const constructMicrosoftRedirectUrl = () => {
    return window.location.origin + '/microsoft-authorization';
};

const ForceMicrosoftAuthenticationPage = () => {
    const { user } = useAuthSelector();

    const clientLogoData = useQuery({
        queryKey: ['appClientLogo'],
        queryFn: () => getClientLogo(window.location.host),
    });

    const clientSignInLogoData = useQuery({
        queryKey: ['appClientSignLogo'],
        queryFn: () => getClientSignInLogo(window.location.host),
    });

    const logoUrl = clientSignInLogoData.data?.signInLogoUrl || clientLogoData.data?.logoUrl;

    const getMicrosoftData = useQuery({
        queryKey: ['microsoft-details'],
        queryFn: () => getMicrosoftDetails(),
    });

    const microsoftAuthorizeQuery = useQuery({
        queryKey: ['microsoft-auth-url'],
        queryFn: () =>
            getMicrosoftSSOAuthUrl({
                type: 'link',
                userId: user._id,
                // redirectUri: `${window.location.origin}/plugins/${pluginId}/microsoft`,
                redirectUri: `${window.location.origin}/dashboard`,
            }),
    });

    const handleSubmit = async () => {
        try {
            const redirectUri = constructMicrosoftRedirectUrl();

            toast.warning('Redirecting to Microsoft.');

            const state = encodeURIComponent(
                JSON.stringify({ pluginId: getMicrosoftData.data?._id, url: window.location.origin })
            );

            window.location.href = `${microsoftAuthorizeQuery.data?.authUrl}&redirect_uri=${redirectUri}&state=${state}`;

            // onAuthorize();
        } catch (err: any) {
            toast.error(err?.message || 'Some error occurred, please try again');
        }
    };

    return (
        <div>
            <div className="bg-white p-8 sm:p-[52px] rounded-lg">
                <div className="flex items-center justify-between gap-4">
                    {logoUrl && (
                        <div>
                            <img src={logoUrl} alt="logo" className="h-16 object-contain" />
                        </div>
                    )}
                </div>

                <div className="mt-10">
                    <img
                        src={'/plugins-images/microsoft.svg'}
                        alt="microsoft"
                        style={{
                            width: 132,
                            height: 32,
                        }}
                    />

                    <h3 className="mt-6">SSO Activation</h3>

                    <div className="text-grayscale-500 mt-3">
                        You need to link your account before you can access ProgressCenter
                    </div>

                    <div className="mt-8">
                        <div className="bg-card-color rounded-b-2xl max-w-2xl">
                            <div className="flex flex-col gap-6 mt-8">
                                <ActionButton onClick={handleSubmit} loadingText="Linking Account">
                                    Link Account
                                </ActionButton>
                            </div>
                        </div>
                    </div>

                    <div className="mt-14">
                        <div className="flex items-center gap-3">
                            <div className="text-grayscale-500">Avaliable on</div>
                            <div className="flex items-center gap-4">
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://apps.apple.com/in/app/progresscenter/id1561585562"
                                    className="grid place-items-center w-9 h-9 rounded-full border border-grayscale-300"
                                >
                                    <img src="/icons/ios.svg" alt="" />
                                </a>

                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://play.google.com/store/apps/details?id=com.progresscenter.app"
                                    className="grid place-items-center w-9 h-9 rounded-full border border-grayscale-300"
                                >
                                    <img src="/icons/android.svg" alt="" />
                                </a>

                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://d14os2kprk7f9m.cloudfront.net/apps/v4/ProgressCenter.dmg"
                                    className="grid place-items-center w-9 h-9 rounded-full border border-grayscale-300"
                                >
                                    <img src="/icons/apple.svg" alt="" />
                                </a>

                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="https://d14os2kprk7f9m.cloudfront.net/apps/v4/ProgressCenter.zip"
                                    className="grid place-items-center w-9 h-9 rounded-full border border-grayscale-300"
                                >
                                    <img src="/icons/windows.svg" alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForceMicrosoftAuthenticationPage;
